import(/* webpackMode: "eager" */ "/vercel/path1/src/app/global-error.tsx");
